// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cash-details>div[data-v-a094c850]{padding:.5rem 0}", "",{"version":3,"sources":["webpack://./src/resources/js/tenant/Components/View/POS/RegisterInfoModal.vue"],"names":[],"mappings":"AACA,mCACI,eAAJ","sourcesContent":["\n.cash-details > div\n    padding: 0.5rem 0\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
